import * as React from "react";
import { observer } from "mobx-react";
import { Loader, Message } from "sb-resp-ui";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { RacingCurrentEventsData } from "./data";
import { LeagueEventsCompositeModel } from "./data/LeagueEventsCompositeModel";
import { BranchViewEventModel } from "./data/BranchViewEventModel";

// external components
import * as CMP from "./components";
import * as SCMP from "../../components";

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the RacingCurrentEvents component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

@observer
export class RacingCurrentEvents extends React.Component<{
    dataProvider: RacingCurrentEventsData,
    dict: BaseDict
}, {
    dataProvider: RacingCurrentEventsData
}> {
    dict: BaseDict

    constructor(props) {
        super(props);

        this.dict = this.props.dict;
        this.state = {
            dataProvider: this.props.dataProvider,
        }
    }

    /* istanbul ignore next */
    renderRows(rows: LeagueEventsCompositeModel[]) {
        return rows.map(x => {
            return (
                <CMP.Row key={x.id}>
                    <CMP.Place label={x.leagueName} hasLiveStream={x.hasLiveStream} />
                    <CMP.Events>
                        {this.renderEvents(x.events)}
                    </CMP.Events>
                </CMP.Row>
            )
        });
    }

    /* istanbul ignore next */
    renderEvents(events: BranchViewEventModel[]) {
        return events.map(x => this.renderEvent(x));
    }

    /* istanbul ignore next */
    renderEvent(event: BranchViewEventModel) {
        return (
            <SCMP.Event
                key={event.id}
                url={event.url}
                label={event.title}
                status={this.state.dataProvider.racingStore.getEventStatus(event.raceProgress)}
                handler={event.handler ? event.handler : () => { }}
            />
        )
    }

    /* istanbul ignore next */
    renderLoader() {
        return (
            <div className="rj-racing-current-races__loader">
                <Loader />
            </div>
        )
    }

    renderMessageOrLoader() {
        if (!this.state.dataProvider.racingStore.isTodayEventsPresent) {
            return (<Message text={this.dict.NoMarketsAvailable} />)
        }
        else {
            return this.renderLoader()
        }
    }

    /* istanbul ignore next */
    render() {
        let l = this.state.dataProvider.branchViewLeagueEvents.length;
        return (
            <div className="rj-racing-current-races">
                {
                    (!l || l === 0) && this.renderMessageOrLoader()
                }
                {
                    (l > 0) && this.renderRows(this.state.dataProvider.branchViewLeagueEvents)
                }

                {/* {process.env.NODE_ENV === "development" && (
                    <DevTools />
                )} */}
            </div >
        )
    }
}